
  import { useBooleanLocalStorage } from '@/services/storage';
  import { Box } from '@/ui/components/Box';
  import ChevronIcon from '@/ui/components/icon/ChevronIcon.vue';
  import { defineComponent } from 'vue';

  export interface CollapsibleProperties {
    collapsible?: boolean;
  }

  interface WidgetProperties extends CollapsibleProperties {
    title: string;
    emptyTitle?: string;
    emptyDescription?: string;
    emptyImage?: string;
    isEmpty?: boolean;
  }

  export default defineComponent<WidgetProperties>({
    components: {
      ChevronIcon,
      Box,
    },
    props: ['title', 'emptyTitle', 'emptyDescription', 'emptyImage', 'isEmpty', 'collapsible'],
    setup(props) {
      const { value: collapsed, set: setCollapsed } = useBooleanLocalStorage(props.title, false);
      if (!props.collapsible) {
        collapsed.value = false;
      }

      const toggleCollapse = () => {
        if (!props.collapsible) {
          return;
        }

        setCollapsed(!collapsed.value);
      };

      return {
        collapsed,
        toggleCollapse,
      };
    },
  });
